<template>
  <div class="outdated-paid-not-refunded">
    <div class="subpage-header">
      <h2 class="normal" id="page-title-for-sr">
        <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
        <span aria-live="assertive" role="status" v-html="$t('confirmation.outdatedPaidNotRefunded.header')"></span>
      </h2>
    </div>
    <p v-html="$t('confirmation.outdatedPaidNotRefunded.description')"></p><p v-html="$t('confirmation.outdatedPaidNotRefunded.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationOutdatedPaidNotRefunded'
}
</script>
